import { useState, useEffect, useContext, useRef } from 'react';

import { PracticeReseveContext } from '../../../../../PracticeReseveContext';
import PracticeReserveSituationCaseCategoryBusiness from './business/PracticeReserveSituationCaseCategoryBusiness';
import PracticeReserveSituationCaseCategoryPronunciation from './pronunciation/PracticeReserveSituationCaseCategoryPronunciation';
import PracticeReserveSituationCaseCategoryLine from './line/PracticeReserveSituationCaseCategoryLine';

import { PracticeReserveSituationValue } from '../../../../../../../../models/practice/reserve/situation/PracticeReserveSituation';
import { PracticeReserveSituationType } from '../../../../../../../../models/practice/reserve/situation/type/PracticeReserveSituationType';


// シチュエーションごと
function PracticeReserveSituationCaseCategory(props: any) {

  const type: PracticeReserveSituationType = props.type;

  const {
    config, vars, user, title,
  } = useContext(PracticeReseveContext);

  const category: string = props.category;
  const lineList: PracticeReserveSituationValue = props.lineList;
  const label: string = props.label;

  const openCateKey = props.openCateKey;
  const setOpenCateKey = props.setOpenCateKey;
  const cateRef = props.cateRef;

  const [isDisp, setIsDisp] = useState<boolean>(false);
  const [isBusiness, setIsBusiness] = useState<boolean>(false);
  const [isPronunciation, setIsPronunciation] = useState<boolean>(false);


  // 表示判定
  useEffect(() => {
    const groupId = type?.groupId;
    if(groupId) {
      setIsDisp(
        category !== '97' &&
        config.practice_category_group[groupId].includes(Number(category))
      );
    }
  }, [type, category])

  // ビジネスコース判定
  useEffect(() => {
    setIsBusiness(
      Boolean(title) &&
      Number(category) === 5 &&
      !user.course_biz
    );
  }, [category])

  // 発音コース判定
  useEffect(() => {
    setIsPronunciation(
      Boolean(title) &&
      Number(category) === 12 &&
      !user.course_pronunciation &&
      !user.course_pronunciation2
    );
  }, [category])

  const chgOpenCate = () => {
    if(openCateKey == category) {
      // 開いている場合→閉じる
      setOpenCateKey('');
    } else {
      // 閉じている場合→開く
      setOpenCateKey(category);
    }
  }


  return (
    <>
    {isDisp &&
      <div ref={cateRef} key={category}>
        <div
          className="list-group-item list-group-item-info"
          style={{ cursor: 'pointer' }}
          onClick={chgOpenCate}
        >
          <strong>{label}</strong>
          <span className="glyphicon glyphicon-chevron-down pull-right"></span>
        </div>

        {openCateKey == category &&
          <div id={`situation_${category}`}>
            <ul className="list-group" style={{ marginBottom: '2px' }}>

              {/* ビジネスコース / 発音コース */}
              {isBusiness ? (
                <>
                  {/* ビジネスコース */}
                  <PracticeReserveSituationCaseCategoryBusiness
                    category={category}
                  />
                </>
              ) : isPronunciation ? (
                <>
                  {/* 発音コース */}
                  <PracticeReserveSituationCaseCategoryPronunciation
                    category={category}
                  />
                </>
              ) : null}

              {/* シチュエーション選択行 */}
              {lineList &&
                Object.entries(lineList).map(([key, info]) => (
                  <PracticeReserveSituationCaseCategoryLine
                    key={key}
                    category={category}
                    info={info}
                    isBusiness={isBusiness}
                    isPronunciation={isPronunciation}
                  />
                ))
              }

            </ul>
          </div>
        }

      </div>
    }
    </>
  );
}
  
export default PracticeReserveSituationCaseCategory;